import { DateTime } from 'luxon';
import { identityContentSchema } from './types';
import { countryNamesByCode, IDKind } from '@startuptools/common/common';
import { z } from 'zod';
import { JuridicalKind } from '@startuptools/business-ui/identity/types';

export const renderTextField = (value: string) => {
  return value;
};

export const renderIdentity = (value: z.infer<typeof identityContentSchema>): string => {
  if (value.language === 'sv') {
    switch (value.identityNumberKind) {
      case IDKind.SwedishOrgNumber:
        return `${value.name}, ett bolag registrerat i Sverige med organisationsnummer ${value.identityNumber}`;

      case IDKind.SwedishPersonalID:
        return `${value.name}, en fysisk person boende i Sverige med personnummer ${value.identityNumber}`;

      case IDKind.ForeignManual: {
        if (!value.countryCode) return `${value.name}`;
        const country = countryNamesByCode['sv'][value.countryCode]?.name;
        if (value.juridicalKind === JuridicalKind.Company) {
          return `${value.name}, ett bolag registrerat i ${country}`;
        }
        return `${value.name}, en fysisk person boende i ${country}`;
      }

      default:
        return `${value.name}`;
    }
  }

  switch (value.identityNumberKind) {
    case IDKind.SwedishOrgNumber:
      return `${value.name}, a joint stock company registered in Sweden with company registration number ${value.identityNumber}`;

    case IDKind.SwedishPersonalID:
      return `${value.name}, a physical person living in Sweden with personal number ${value.identityNumber}`;

    case IDKind.ForeignManual: {
      if (!value.countryCode) return `${value.name}`;
      const country = countryNamesByCode['en'][value.countryCode]?.name;
      if (value.juridicalKind === JuridicalKind.Company) {
        return `${value.name}, a joint stock company registered in ${country}`;
      }
      return `${value.name}, a physical person living in ${country}`;
    }

    default:
      return `${value.name}`;
  }
};

export const renderDate = (value: Date) => {
  return DateTime.fromJSDate(value).toLocaleString(DateTime.DATE_SHORT);
};
